import { Component, Vue } from 'vue-property-decorator';
import CalendarSetting from '@/components/CalendarSetting/CalendarSetting.vue';
import Calendar from '@/components/Calendar/Calendar.vue';
import CalendarDetail from '@/components/CalendarDetail/CalendarDetail.vue';
import { CalendarFilter, PlantingPlanIds, AgriFieldList, Machine, WorkerList, PlantingList, WorkItem } from '@/types';

@Component({
    components: {
        CalendarSetting,
        Calendar,
        CalendarDetail
    }
})
export default class CalendarPage extends Vue {
    private selectedPlantingPlanIds: PlantingPlanIds | null = null;
    private selectedDate = '';
    private selectedType = '';
    private isOpen = false;
    private calendarFilter: CalendarFilter = {
        dispWorkSchedule: true,
        dispWorkActual: true,
        dispHarvest: true,
        dispShipping: true,
        dispPlantingPlan: false,
        agriFieldIds: [],
        workerIds: [],
        machineIds: [],
        plantingIds: [],
        workItemIds: [],
        includeNoPlanting: true,
        includeNoWorker: true,
        includeNoMachine: true
    };
    private dispWorkSchedule = true;
    private dispWorkActual = true;
    private dispHarvest = true;
    private dispShipping = this.isAdmin;
    private dispPlantingPlan = false;
    private agriFields: AgriFieldList[] = [];
    private agriFieldIds: string[] = [];
    private workers: WorkerList[] = [];
    private workerIds: string[] = [];
    private machines: Machine[] = [];
    private machineIds: string[] = [];
    private plantings: PlantingList[] = [];
    private plantingIds: string[] = [];
    private includeNoPlanting = true;
    private includeNoWorker = true;
    private includeNoMachine = true;
    private workItems: WorkItem[] = [];
    private workItemIds: string[] = [];
    private deleteId = "";
    private applyFilter = false;
    private isFilteredUpdated = false;
    private selectcate: 'KIROKU' | 'SAKUTSUKE' | 'HOJOU' | 'SAGYOUSYA' | 'KIKAI' | 'SAGYOUKOUMOKU' = 'KIROKU';
    private searchWord = '';
    private displayPlantings: Array<PlantingList> = [];
    private displayAgriFields: Array<AgriFieldList> = [];
    private displayWorkers: Array<WorkerList> = [];
    private displayMachines: Array<Machine> = [];
    private displayWorkItems: Array<WorkItem> = [];
    private displayIncludeNoPlanting = true
    private displayIncludeNoWorker = true
    private displayIncludeNoMachine = true
    private storedCalendarFilter = this.$store.getters.calendarFilter
    private openDetail = false
    private isDatePickerOpen = false
    private sortModalToggle = false

    private created() {
        this.init()
    }

    private init() {
        this.getAgriFields();
        this.getWorkers();
        this.getMachines();
        this.getPlantings();
        this.getWorkItems();

        if(this.storedCalendarFilter){
            this.calendarFilter = this.storedCalendarFilter
            this.dispHarvest = this.storedCalendarFilter.dispHarvest
            this.dispPlantingPlan = this.storedCalendarFilter.dispPlantingPlan
            this.dispShipping = this.storedCalendarFilter.dispShipping
            this.dispWorkActual = this.storedCalendarFilter.dispWorkActual
            this.dispWorkSchedule = this.storedCalendarFilter.dispWorkSchedule
            this.agriFieldIds = this.storedCalendarFilter.agriFieldIds
            this.plantingIds = this.storedCalendarFilter.plantingIds
            this.workItemIds = this.storedCalendarFilter.workItemIds
            this.workerIds = this.storedCalendarFilter.workItemIds
            this.machineIds = this.storedCalendarFilter.machineIds
            this.includeNoMachine = this.storedCalendarFilter.includeNoMachine
            this.includeNoPlanting = this.storedCalendarFilter.includeNoPlanting
            this.includeNoWorker = this.storedCalendarFilter.includeNoWorker
            this.applyFilter = true
            this.isFilteredUpdated = !this.isFilteredUpdated
        }
        this.calendarFilter.dispShipping = this.dispShipping;
    }

    private get isAdmin(): boolean {
        let isAdmin = false;
        const loginUser = this.$store.getters.loginUser;
        loginUser.role.forEach((roleName: string) => {
          if (roleName === 'ADMIN') {
            isAdmin = true;
          }
        });
        return isAdmin;
      }

    private getAgriFields() {
        this.$apiClient.doRequest('get', `/agri_fields?with_hidden=true`).then((ret) => {
            this.agriFields = ret.agri_fields;
            this.agriFieldIds = this.storedCalendarFilter ? this.storedCalendarFilter.agriFieldIds : ret.agri_fields.map((agriField: AgriFieldList) => {
                return agriField.id;
            });
            Vue.set(this.calendarFilter, 'agriFieldIds', this.agriFieldIds);
        });
    }
    private getWorkers() {
        this.$apiClient.doRequest('get', `/workers?with_hidden=true`).then((ret) => {
            this.workers = ret.workers;
            this.workerIds = this.storedCalendarFilter ? this.storedCalendarFilter.workerIds : ret.workers.map((worker: WorkerList) => {
                return worker.id;
            });
            Vue.set(this.calendarFilter, 'workerIds', this.workerIds);
        });
    }
    private getMachines() {
        this.$apiClient.doRequest('get', `/machines?with_hidden=true`).then((ret) => {
            this.machines = ret.machines;
            this.machineIds = this.storedCalendarFilter ? this.storedCalendarFilter.machineIds : ret.machines.map((machine: Machine) => {
                return machine.id;
            });
            Vue.set(this.calendarFilter, 'machineIds', this.machineIds);
        });
    }
    private getPlantings() {
        this.$apiClient.doRequest('get', `/plantings?with_hidden=true`).then((ret) => {
            this.plantings =  ret.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name))
            this.plantingIds = this.storedCalendarFilter ? this.storedCalendarFilter.plantingIds : ret.plantings.map((planting: PlantingList) => {
                return planting.id;
            });
            Vue.set(this.calendarFilter, 'plantingIds', this.plantingIds);
        });
    }
    private getWorkItems() {
        this.$apiClient.doRequest('get', `/work_items?with_hidden=true`).then((ret) => {
            this.workItems = ret.work_items;
            this.workItemIds = this.storedCalendarFilter ? this.storedCalendarFilter.workItemIds : ret.work_items.map((workItem: WorkItem) => {
                return workItem.id;
            });
            Vue.set(this.calendarFilter, 'workItemIds', this.workItemIds);
        })
    }


    private dateClicked(date: string) {
        this.openDetail = true
        if (this.selectedDate !== date) {
            this.selectedType = 'day';
            this.selectedPlantingPlanIds = null;
            this.selectedDate = date;
        }
        this.isFilteredUpdated = !this.isFilteredUpdated;
    }

    private eventClicked(plantingPlanIds: PlantingPlanIds) {
        if (this.selectedPlantingPlanIds?.plantingId !== plantingPlanIds.plantingId || this.selectedPlantingPlanIds.workItemId !== plantingPlanIds.workItemId) {
            this.selectedType = 'planting';
            this.selectedPlantingPlanIds = plantingPlanIds;
            this.selectedDate = '';
        }
    }

    private formatDate(date: Date): string {
        const y = date.getFullYear();
        const m = ('00' + (date.getMonth() + 1)).slice(-2);
        const d = ('00' + date.getDate()).slice(-2);

        return (y + '-' + m + '-' + d);
    }

    private openModal() {
        this.init()
        this.isOpen = true;
    }

    private closeModal() {
        this.$root.$emit('header-inert', false);
        this.sortModalToggle = false
        this.isOpen = false;
    }

    private closeDetail() {
        this.openDetail = false
    }

    private get refs(): any {
        return this.$refs;
    }

    private save() {
        this.calendarFilter.dispWorkSchedule = this.dispWorkSchedule;
        this.calendarFilter.dispWorkActual = this.dispWorkActual;
        this.calendarFilter.dispHarvest = this.dispHarvest;
        this.calendarFilter.dispShipping = this.dispShipping;
        this.calendarFilter.dispPlantingPlan = this.dispPlantingPlan;
        Vue.set(this.calendarFilter, 'agriFieldIds', this.agriFieldIds);
        Vue.set(this.calendarFilter, 'workerIds', this.workerIds);
        Vue.set(this.calendarFilter, 'machineIds', this.machineIds);
        Vue.set(this.calendarFilter, 'plantingIds', this.plantingIds);
        Vue.set(this.calendarFilter, 'workItemIds', this.workItemIds);
        this.calendarFilter.includeNoPlanting = this.includeNoPlanting;
        this.calendarFilter.includeNoWorker = this.includeNoWorker;
        this.calendarFilter.includeNoMachine = this.includeNoMachine;

        this.$store.dispatch('doUpdateCalendarFilter', this.calendarFilter);

        // this.calendarFilter.agriFieldIds = this.agriFieldIds;
        // this.calendarFilter.workerIds = this.workerIds;
        // this.calendarFilter.machineIds = this.machineIds;
        // this.calendarFilter.plantingIds = this.plantingIds;
        this.isOpen = false;
        this.applyFilter = true;
        this.isFilteredUpdated = !this.isFilteredUpdated;
        if(!this.storedCalendarFilter)
            this.storedCalendarFilter = this.calendarFilter

        this.$nextTick(()=>{
            this.refs.calendar.updateFilter()
        })
        this.$root.$emit('header-inert', false);
        this.sortModalToggle = false
    }

    private deleteRecord(id: string) {
        this.deleteId = id;
    }

    changeSelectcate(key: 'KIROKU' | 'SAKUTSUKE' | 'HOJOU' | 'SAGYOUSYA' | 'KIKAI' | 'SAGYOUKOUMOKU') {
        this.selectcate = key
        this.searchWord = ''
        this.filterList()
    }

    filterList() {
        switch(this.selectcate) {
            case 'SAKUTSUKE':
                this.displayPlantings = this.plantings.filter(x => x.name.includes(this.searchWord))
                this.displayIncludeNoPlanting = '作付がない記録'.includes(this.searchWord)
                break;
            case 'HOJOU':
                this.displayAgriFields = this.agriFields.filter(x => x.name.includes(this.searchWord))
                break;
            case 'SAGYOUSYA':
                this.displayWorkers = this.workers.filter(x => x.name.includes(this.searchWord))
                this.displayIncludeNoWorker = '作業者がない記録'.includes(this.searchWord)
                break;
            case 'KIKAI':
                this.displayMachines = this.machines.filter(x => x.name.includes(this.searchWord))
                this.displayIncludeNoMachine = '機械がない記録'.includes(this.searchWord)
                break;
            case 'SAGYOUKOUMOKU':
                this.displayWorkItems = this.workItems.filter(x => x.name.includes(this.searchWord))    
                break;
            default:
                break;
        }
    }

    clearCheckAll() {
        switch(this.selectcate) {
            case 'SAKUTSUKE':
                this.plantingIds = []
                this.includeNoPlanting = false
                break;
            case 'HOJOU':
                this.agriFieldIds = []
                break;
            case 'SAGYOUSYA':
                this.workerIds = []
                this.includeNoWorker = false
                break;
            case 'KIKAI':
                this.machineIds = []
                this.includeNoMachine = false
                break;
            case 'SAGYOUKOUMOKU':
                this.workItemIds = []
                break;
            default:
                break;
        }
    }

    selectCheckAll() {
        switch(this.selectcate) {
            case 'SAKUTSUKE':
                this.plantingIds = this.margeSelectedIds(this.plantingIds, this.displayPlantings)
                this.includeNoPlanting = true
                break;
            case 'HOJOU':
                this.agriFieldIds = this.margeSelectedIds(this.agriFieldIds, this.displayAgriFields)
                break;
            case 'SAGYOUSYA':
                this.workerIds = this.margeSelectedIds(this.workerIds, this.displayWorkers)
                this.includeNoWorker = true
                break;
            case 'KIKAI':
                this.machineIds = this.margeSelectedIds(this.machineIds, this.displayMachines)
                this.includeNoMachine = true
                break;
            case 'SAGYOUKOUMOKU':
                this.workItemIds = this.margeSelectedIds(this.workItemIds, this.displayWorkItems)
                break;
            default:
                break;
        }
    }

    private margeSelectedIds(itemIds: string[], displayItems: {id: string}[]): string[] {
        // 元の配列に追加分の配列をマージ＋重複を排除して返却
        return Array.from(new Set(itemIds.concat(displayItems.map(d => d.id))))
    }

    private handleDatePickerToggle(val: boolean) {
        this.isDatePickerOpen = val
    }

    private handleSortModalToggle(val: boolean) {
        this.sortModalToggle = val
    }
}